import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/coach-engagement')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/professionals/engagement' });
  },
});
